import React, { useEffect } from 'react'
import { AbstructVar } from '../../general/general-component/abstruct-component/AbstructVar'
import { useParams } from 'react-router-dom'
import { emptyEvaluationDetailsByReader, loadEvaluationDetailsByReader } from '../../../store/Actions/ActionEvaluationDetails'
import InnerLoader from '../../general/inner-loader/InnerLoader'
import { useSelectorCustom } from '../../general/general-component/abstruct-component/useSelectorCustom'
import { UsePermissions, hasPermissions } from '../../general/general-component/abstruct-component/UsePermissions'
import CheckPermissions from '../../general/general-component/check-permissions'

function EvaluationDetailsByReader() {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const project_requests = hasPermissions([{ name: "project-requests" }], permissionss)
    const { dispatch, langLocal, navigate } = AbstructVar()
    let { creativeWorkId, readerId } = useParams()
    const { evaluationDetailsByReader, loadingevaluationDetailsByReader } = useSelectorCustom()
    useEffect(() => {
        dispatch(loadEvaluationDetailsByReader(readerId, creativeWorkId))
        return (() => {
            dispatch(emptyEvaluationDetailsByReader())
        })
    }, [])
    const getBackgroundColor = (evaluation) => {
        switch (evaluation) {
            case 'unacceptable':
                return 'unacceptable';
            case 'poor':
                return 'poor';
            case 'satisfactory':
                return 'satisfactory';
            case 'good':
                return 'good';
            case 'excellent':
                return 'excellent';
            default:
                return '#FFFFFF';
        }
    };
    return (
        <>
            <CheckPermissions array={project_requests} loadingMainPermission={loadingMainPermission} >
                <main>
                    <div className="div_details margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                        {
                            loadingevaluationDetailsByReader === false ? (
                                <>
                                    <div className='div_note' >
                                        {
                                            evaluationDetailsByReader.notes.map((note) => {
                                                return (
                                                    <p>{note.notes}</p>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className='all_question'>
                                        {
                                            evaluationDetailsByReader.evaluations.map((evaluation) => {
                                                return (
                                                    <div className='one_evaluation_reader' >
                                                        <div className='top_one_evaluation_reader' >
                                                            <div className='without_degree' >
                                                                <p className='without_degree_p' >
                                                                    {evaluation.evaluation_type.name}
                                                                </p>
                                                                <span className={`div_status ${getBackgroundColor(evaluation.quality)}`} >
                                                                    {evaluation.quality}
                                                                </span>
                                                            </div>
                                                            <div className='div_degree' >
                                                                <span className='num_degree' >{evaluation.degree}</span>
                                                                <span>Degree</span>
                                                            </div>
                                                        </div>

                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </>
                            ) : <InnerLoader />
                        }
                    </div>
                </main>
            </CheckPermissions>


        </>
    )
}

export default EvaluationDetailsByReader